$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
Browser = require '@trello/browser'
CardComposerInlineView = require 'app/scripts/views/card-composer/card-composer-inline-view'
{ maybeDisplayLimitsErrorOnCardAdd, canAddCard } = require 'app/scripts/views/card/card-limits-error'
CardListView = require 'app/scripts/views/card/card-list-view'
Controller = require 'app/scripts/controller'
require 'app/scripts/views/internal/data-transfer/drag-drop-events'
DragSort = require 'app/scripts/views/lib/drag-sort'
View = require 'app/scripts/views/internal/view'
ListMenuView = require 'app/scripts/views/list/list-menu-view'
PopOver = require 'app/scripts/views/lib/pop-over'
TrelloClipboard = require 'app/scripts/lib/trello-clipboard'
parseTrelloUrl = require 'app/scripts/lib/util/url/parse-trello-url'
parseUrl = require 'url-parse'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
Promise = require 'bluebird'
PasteInput = require 'app/scripts/views/internal/paste-input'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
log = require 'app/scripts/debug/log'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
templates = require 'app/scripts/views/internal/templates'
listTemplate = require 'app/scripts/views/templates/list'
{ track, trackUe, Noun, Verb } = require '@trello/analytics'
localizeCount = require 'app/scripts/lib/localize-count'
warnIfFileTooLarge = require 'app/scripts/views/internal/warn-if-file-too-large'
pastedFileName = require 'app/scripts/views/internal/pasted-file-name'
{ getKey, Key } = require '@trello/keybindings'
l = require 'app/scripts/lib/localize'
{ featureFlagClient } = require '@trello/feature-flag-client'
f = require 'effing'
ninvoke = require 'app/scripts/lib/util/ninvoke'
removeAllRanges = require 'app/scripts/lib/util/removeAllRanges'
{ sendPluginTrackEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
IdCache = require 'app/scripts/db/id-cache'
ModelLoader = require 'app/scripts/db/model-loader'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ CardTemplatesButton } = require 'app/src/components/CardTemplatesPopover'
{ getSeparatorClassName } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'
{ Analytics } = require '@trello/atlassian-analytics'

module.exports = class ListView extends View
  className: 'js-list list-wrapper'

  events:
    'mouseenter .js-open-list-menu': 'preloadMenu'
    'click .js-open-list-menu': 'openMenu'
    'mousedown .list-cards': 'eventStopPropagation'
    'click .js-open-card-composer': 'openCardComposer'

    'keydown  .js-list-name-input': 'keyDownEvent'
    'blur     .js-list-name-input': 'stopEditing'

    'click    .js-editing-target': 'startEditing'
    'focus    .js-list-name-input': 'startEditing'

    'movelist': 'moveList'

    'sortreceive': 'sortReceive'
    'sortcommit': 'sortCommit'

    'dd-drop:files': 'dropFiles'
    'dd-drop:text': 'dropText'
    'dd-drop:url': 'dropUrl'

    'mouseenter': 'mouseenter'
    'mouseleave': 'mouseleave'
    'mousemove': 'mousemove'
    'pasteinput:text': 'dropText'
    'pasteinput:files': 'dropFiles'
    'pasteinput:url': 'dropUrl'

  initialize: ->
    super

    @fEditingName = false

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

    @makeDebouncedMethods 'render', 'toggleComposerLink', 'renderComposer',
      'renderCardCount', 'renderName', 'renderAddButton', 'renderListLimit'

    @listenTo @model,
      'change:limits': @renderLimits
      'change:name': @renderNameDebounced
      'change:subscribed': @renderSubscribed
      'change:softLimit': @renderListLimit
      'change:id': @renderCardTemplateButton

    @listenTo @model.cardList,
      'add remove change:idList change:closed reset': ->
        @renderCardCountDebounced()
        @renderAddButtonDebounced()
        @renderListLimitDebounced()

    @listenTo @model.getBoard().boardPluginList, 'add remove', =>
      @renderListLimitDebounced()

    @listenTo @model.getBoard(), 'permChange', @renderEditable

    @listenTo @model.getBoard().composer,
      'change:list change:index change:vis': @renderComposerDebounced
      'change:list change:vis': ->
        @toggleComposerLinkDebounced()

    @listenTo @model.getBoard(), 'change:prefs.isTemplate': @renderDebounced

    @cardListView = @collectionSubview CardListView, @model.cardList,
      className: 'list-cards u-fancy-scrollbar u-clearfix js-list-cards'
      deferCards: @options.deferCards

    $(window).on "resize.#{@uniqueId()}", f(@, 'hackFlexboxForSadBrowsers')

    for eventName in ['mouseEnterCardView', 'mouseLeaveCardView', 'mouseMoveCardView']
      do (eventName) =>
        @listenTo @cardListView, eventName, (cardView) ->
          @trigger eventName, cardView

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', false, (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

    return

  isTemplate: ->
    @templateFlagEnabled && @model.isTemplate()

  renderLimits: ->
    limited = !canAddCard({ destinationList: @model })
    @cardListView.$el.toggleClass 'card-limits-full', limited
    @

  render: ->
    log('render', "rendering list " + @model.get('name'))

    @cardListView.$el.detach()

    @$el.html listTemplate
      name: @model.get('name')
      subscribed: @model.get('subscribed')
      loggedIn: Auth.isLoggedIn()
      editable: @model.editable()
      isTemplate: @isTemplate()

    @cardListView.$el.insertAfter @$('.js-list-header')
    @cardListView.render()
    @cardListView.$el.toggleClass 'js-sortable', @model.editable()

    @renderLimits()

    @renderListLimit()

    @toggleComposerLinkDebounced()
    @renderComposerDebounced()

    @renderCardCount()
    @renderEditable()
    @renderAddButton()
    @renderCardTemplateButton()

    @hackFlexboxForSadBrowsers()

    # The short delay causes the UI thread to complete before calling autosize.
    # We'll call autosize in react's componentDidMount when it comes to this
    # view eventually.
    _.defer =>
      @$('.js-list-name-input').autosize(append: false)

    @

  remove: ->
    $(window).off ".#{@uniqueId()}"
    @removeCardTemplateButton()
    super

  renderName: ->

    @$('.js-list-name-assist').text(@model.get('name'))

    # don't update while your typing.
    if !@fEditingName

      @$('.js-list-name-input')
        .val(@model.get('name'))
        .trigger('autosize.resize', false)

    @

  renderSubscribed: ->
    @$('.js-list-subscribed').toggleClass('hide', !@model.get('subscribed'))
    @$('.js-list-header').toggleClass('is-subscribe-shown', @model.get('subscribed'))
    @$('.js-list-name-input').trigger('autosize.resize', false)
    @

  renderEditable: ->
    # NOTE: The best thing to do here is probably to toggle an 'editable' or
    # 'readonly' class on the $el, and use CSS to control the visibility of
    # things.  Not making this change because a lot of the templates are being
    # re-written.
    editable = @model.editable()

    @$('.js-list-cards').toggleClass('js-sortable', editable)

    if !editable
      @$('.js-list-name-input').attr('disabled', 'disabled')
    else
      @$('.js-list-name-input').removeAttr('disabled')

    @$('.js-open-card-composer').toggleClass('hide', !editable)

    DragSort.refreshListCardSortable()

    @

  hackFlexboxForSadBrowsers: ->
    if Browser.browserVersionStr !in ["explorer-10", "explorer-11"]
      return
    @defer =>
      $list = @$el
      listHeaderHeight = @$('.list-header').outerHeight()
      composerHeight = @$('.open-card-composer').outerHeight()
      boardHeight = $('#board').height()
      height = boardHeight - listHeaderHeight - composerHeight - 20
      @$('.list-cards').css('max-height': height)
    return

  saveListName: (e) ->
    $input = @$('.js-list-name-input')

    name = @model.get('name')
    newValue = $input.val()

    # remove new lines and extra whitespace
    newValue = newValue.replace(/\s+/g, ' ').trim()

    # if it's the same name, don't save
    if newValue == name
      return

    # if it's too long, don't save
    if newValue.length > 16384
      return

    # don't save if empty.
    if newValue.trim().length == 0
      return

    # We should handle the returned `err` someday…
    @model.update 'name', newValue

    return

  keyDownEvent: (e) ->

    if getKey(e) == Key.Enter
      Util.stop(e) # prevents new lines.
      @stopEditing()
      return

    if getKey(e) == Key.Escape
      @stopEditing()
      return

    return

  startEditing: (e) ->
    Util.stop(e)

    if !@fEditingName && @model.editable() && !DragSort.sorting
      @fEditingName = true

      @$('.js-editing-target').addClass('is-hidden')

      _.defer =>
        @$('.js-list-name-input').focus().select().addClass('is-editing')

    return

  stopEditing: (e) ->
    if @fEditingName
      @$('.js-editing-target').removeClass('is-hidden')

      $input = @$('.js-list-name-input').removeClass('is-editing')
      if $input.is(":focus") then $input.blur()
      removeAllRanges()

      @fEditingName = false
      @saveListName()
      @renderNameDebounced()

    return

  toggleComposerLink: ->
    @$('.js-open-card-composer').toggleClass('hide', @composerOpen() || !@model.editable())
    @$('.js-card-composer-container').toggleClass('hide', @composerOpen() || !@model.editable())

  composerOpen: ->
    composer = @model.getBoard()?.composer
    composer? && composer.get('vis') && composer.get('list') == @model

  renderComposer: ->

    if @composerOpen()
      composer = @model.getBoard().composer
      composerView = Controller.getCurrentBoardView().subview(CardComposerInlineView, composer)
      @insertComposerAtIndex(composer.get('index'), composerView)
      composerView.scrollIntoView()
      _.debounce(composerView.delegateEvents(), 150)

    @

  insertComposerAtIndex: (index, composerView) ->
    if index == 0
      @$('.list-cards').prepend(composerView.render().el)
    else
      cardIndex = index - 1
      $cards = @$('.list-card').not('.js-composer')
      if cardIndex >= $cards.length
        cardIndex = $cards.length - 1
      $cards.eq(cardIndex).after(composerView.render().el)
    return

  renderCardCount: ->
    @$('.js-num-cards').text localizeCount('cards', @model.openCards().length)

  openCardComposer: (e) ->
    Util.stop(e)

    PopOver.hide()

    board = @model.getBoard()
    options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: @model,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    board.composer.save({
      list: @model
      index: @model.openCards().length
      vis: true
    })

    track('Card Composer', 'Open', 'Via Bottom of List')

    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'button'
        actionSubjectId: 'addAnotherCardButton',
        source: 'listFooter'
        containers:
          board:
            id: board?.id || ''
          list:
            id: @model?.id || ''
          organization:
            id: board?.getOrganization()?.id || ''

    return

  triggerOnItem: (e, ui, sEvent) ->
    Util.stopPropagation(e)

    # Don't kick off any re-renders until sortable puts the card in the DOM
    @defer => ui.item.trigger(sEvent, [ui, @])

    return

  sortReceive: (e, ui) ->
    @triggerOnItem(e, ui, 'moveto')
    return

  sortCommit: (e, ui) ->
    @triggerOnItem(e, ui, 'movein')
    return

  loadPluginActions: (target, timeout) ->
    PluginRunner.all
      timeout: timeout
      command: 'list-actions'
      el: target
      board: @model.getBoard()
      list: @model
    .catch  ->
      []
    .then (pluginActions) ->
      # limit to three actions per plugin
      _.chain(pluginActions)
        .groupBy('idPlugin')
        .map (val, idPlugin) -> val.slice(0, 3)
        .flatten()
        .value()

  preloadMenu: (e) ->
    if !DragSort.sorting && !@pluginActionsPromise?
      @pluginActionsPromise = @loadPluginActions(e.currentTarget, 500)
      .then (pluginActions) =>
        @pluginActionsPromise = null
        @pluginActions = pluginActions
        @pluginActionsExpiry = Date.now() + 5000
        return pluginActions

  openMenu: (e) ->
    view = @

    if (!DragSort.sorting)
      Util.preventDefault(e)

      track("List Menu", "Open List Menu")

      if @sendGASEvent
        Analytics.sendUIEvent
          action: 'clicked',
          actionSubject: 'button',
          actionSubjectId: 'listMenuButton',
          source: 'listHeader'
          containers:
            board:
              id: @model?.getBoard()?.id || ''
            list:
              id: @model?.id || ''
            organization:
              id: @model?.getBoard()?.getOrganization()?.id || ''

      pluginActions = []

      if @pluginActions? && @pluginActionsExpiry > Date.now()
        pluginActions = @pluginActions
      else if @pluginActionsPromise?
        pluginActions = @pluginActionsPromise
      else
        pluginActions = @loadPluginActions(e.currentTarget, 150)

      Promise.resolve(pluginActions)
      .then (pluginActions) =>
        PopOver.toggle
          elem: e.currentTarget
          view: new ListMenuView({ @model, @modelCache, pluginActions })
        @pluginActions = null

      return false

    return

  moveList: (e, ui) ->
    Util.stop(e)
    lists = ui.item.parent().children()
    pos = lists.index(ui.item)
    @model.move(pos)
    return

  eventStopPropagation: (e) ->
    Util.stopPropagation(e)
    return

  scrollToCard: (card) ->
    cardView = @cardListView.viewForModel card
    Util.scrollElementIntoView @$('.js-list-cards')[0], cardView.el,
      vertical: true
      animated: true
    return

  mouseenter: (e) ->
    @trigger 'mouseEnterListView'
    PasteInput.addHandler @, { scope: 'list' }

  mouseleave: (e) ->
    @trigger 'mouseLeaveListView'
    PasteInput.removeHandler @, { scope: 'list' }

  mousemove: (e) ->
    @trigger 'mouseMoveListView'

  dropText: (e) ->
    if !@model.editable()
      return

    board = @model.getBoard()
    options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: @model,
      hasAttachments: true,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    text = e.detail
    @model.uploadText(text)

  dropUrl: (e) ->
    if !@model.editable()
      return

    board = @model.getBoard()
    options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: @model,
      hasAttachments: true,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    e.stopPropagation()
    url = e.detail

    if board.attachmentUrlRestricted(url)
      return

    parsedTrello = parseTrelloUrl(url)
    if parsedTrello.type == 'card'
      @handlePastedCardUrl(parsedTrello.shortLink, url)
    else
      @createCardFromUrl(url)
    return

  handlePastedCardUrl: (shortLink, url) ->
    Promise.try =>
      idCard = IdCache.getId('Card', shortLink) ? shortLink
      card = @modelCache.get('Card', idCard)
      if card?
        return card
      return ModelLoader.loadCardData(idCard)
    .then (card) =>
      Promise.try =>
        board = card.getBoard()
        if board?.get('memberships')?.length
          return board
        return ModelLoader.loadBoardMinimal(@get('idBoard'))
      .then (board) =>

        if board.get('enterpriseOwned')
          isGuest = board.isGuest(Auth.me())
          if isGuest && board.get('id') != @model.getBoard().get('id')
            Alerts.show(['can only copy within board', {
              boardName: board.get('name')
            }], 'error', 'trello-clipboard', 5000)
            return
          else if board.getOrganization()?.get('idEnterprise') != @model.getBoard().getOrganization()?.get('idEnterprise')
            Alerts.show(['can only copy within enterprise', {
              enterpriseName: board.getEnterprise().get('displayName')
            }], 'error', 'trello-clipboard', 5000)
            return

        if TrelloClipboard.isCut(url) && board.editable()
          event = 'moveCard'
        else
          event = 'copyCard'
        @trigger event,
          shortLink: shortLink
          idList: @model.id

        if me = Auth.me()
          oneTimeMessage = "pasteAlert-#{event}"
          if !me.isDismissed(oneTimeMessage)
            me.dismiss(oneTimeMessage)
    .catch (e) =>
      @createCardFromUrl(url)

  createCardFromUrl: (url) ->
    parsed = parseUrl(url)
    if (domain = parsed.host)?
      PluginRunner.one
        timeout: 2000
        command: 'card-from-url'
        list: @model
        board: @model.getBoard()
        options:
          url: url
      .catch PluginRunner.Error.NotHandled, ->
        {}
      .then (dataFromPlugin) =>
        placeholder = l('loading from domain', { domain })
        cardData = _.pick(dataFromPlugin, 'name', 'desc')
        if dataFromPlugin?.idPlugin
          trackUe('board view', 'creates', 'Power-Up', '', '', 'card-from-url', dataFromPlugin.idPlugin)
        ninvoke @model, 'uploadUrl', url, cardData, placeholder
          .then (data) ->
            sendPluginTrackEvent(dataFromPlugin.idPlugin, {
              action: 'created'
              actionSubject: 'card'
              objectType: 'card'
              objectId: data.id
              source: 'powerUpCardFromUrl'
            })
      .done()

  dropFiles: (e) ->
    if !@model.editable()
      return

    board = @model.getBoard()

    if board.attachmentTypeRestricted('computer')
      return

    options = {
      $elem: $(e.target),
      destinationBoard: board,
      destinationList: @model,
      hasAttachments: true,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    files = e.detail

    if warnIfFileTooLarge(@model.getBoard(), files)
      return

    Promise.resolve(files)
    .each (file) =>
      name = file.name || pastedFileName()
      ninvoke @model, 'upload', file, name
    .catch(->)
    .done()

  renderAddButton: ->
    listIsEmpty =  @model.cardList.length == 0
    @$('.js-add-a-card').toggleClass('hide', !listIsEmpty)
    @$('.js-add-another-card').toggleClass('hide', listIsEmpty)

  renderListLimit: ->
    $listContent = @$('.js-list-content')
    $listLimitBadge = @$('.js-list-limit-badge')
    $listHeader = @$('.js-list-header')
    listLimitsEnabled = @model.getBoard().isListLimitsPowerUpEnabled()

    if listLimitsEnabled
      softLimit = @model.get('softLimit')
      ignoreSeparators = featureFlagClient.get('ecosystem.list-limits-ignore-separators', false)

      if softLimit?
        cardCount = 0
        if ignoreSeparators
          cardCount = @model.cardList.filter((card) ->
              return !getSeparatorClassName(card.get('name'))
          ).length
        else
          cardCount = @model.cardList.length
        hasExceededLimit = cardCount > softLimit

        $listLimitBadge.text "#{cardCount} / #{softLimit}"
        $listHeader.addClass('is-list-limit-shown')
        $listLimitBadge.removeClass('hide')
        $listContent.toggleClass 'exceeds-list-limit', hasExceededLimit
        $listLimitBadge.toggleClass 'mod-warning', hasExceededLimit
      else
        $listContent.removeClass('exceeds-list-limit')
        $listLimitBadge.addClass('hide')
        $listHeader.removeClass('is-list-limit-shown')
    else
      $listContent.removeClass('exceeds-list-limit')
      $listLimitBadge.addClass('hide')
      $listHeader.removeClass('is-list-limit-shown')

  createCardFromTemplate: (name, idCardSource, keepFromSourceArray = []) ->
    new Promise (resolve, reject) =>
      newCard = @model.cardList.create({
        name
        idCardSource
        keepFromSource: keepFromSourceArray.join(',')
      }, {
        error: =>
          @model.cardList.remove(card)
          reject()
        success: (card) =>
          resolve(=> @cardListView.scrollToCardView(card))
      })

      board = @model.getBoard()
      board.filter.addNewCard(newCard)

  renderCardTemplateButton: ->
    if @model.id?
      renderComponent(React.createElement(CardTemplatesButton, {
        idList: @model.id,
        idBoard: @model.getBoard().id,
        createCard: (name, idCardSource, keepFromSourceArray) =>
          if @sendGASEvent
            Analytics.sendTrackEvent
              action: 'created'
              actionSubject: 'card'
              source: 'createCardFromTemplateInlineDialog'
              attributes:
                cardSourceId: idCardSource || ''
              containers:
                board:
                  id: @model?.getBoard()?.id || ''
                list:
                  id: @model?.id || ''
                organization:
                  id: @model?.getBoard()?.getOrganization()?.id || ''
          trackUe({
            category: Noun.CARD_TEMPLATES,
            verb: Verb.COMPLETES,
            directObj: Noun.CREATE_CARD_FROM_TEMPLATE_MENU,
            context: {
              entry: Noun.LIST,
            },
          })
          return @createCardFromTemplate(name, idCardSource, keepFromSourceArray)
      }), @$('.js-card-templates-button')[0])

    @

  removeCardTemplateButton: ->
    if @$('.js-card-templates-button').length
      ReactDOM.unmountComponentAtNode(@$('.js-card-templates-button')[0])
